import React, { Component } from 'react'
import { message }          from 'antd'
import Payment              from "payment"

import CloudFlyerAPI         from '../../api/CloudFlyerAPI'
import PaymentForm        from './PaymentForm'

import './styles.scss'

export default class BillingForm extends Component {

  constructor (props) {
    super(props)
    this.state = {
      billing_modal_visible : false,
      billing_loading       : false,
      billing_valid         : false,
      focused               : '',
      billing : {
        number: '',
        name: '',
        exp: '',
        cvc: ''
      }
    }
  }

  open = on_close => {
    this.setState({
      billing_modal_visible:true, on_close}, ()=>{
      if(document.querySelector('[name="number"]')){
        Payment.formatCardCVC(document.querySelector('[name="cvc"]'))
      }
    })
  }

  on_focus = target => this.setState({focused:target.name})

  on_billing_change = target => {
    const billing = this.state.billing

    if (target.name === 'number') {
      billing[target.name] = target.value.replace(/ /g, '')
    }
    else if (target.name === 'expiry') {
      billing[target.name] = target.value.replace(/[ \/]/g, '')
    }
    else {
      billing[target.name] = target.value
    }

    this.setState({billing: billing})
  }

  billing_callback = (type, isValid) => this.setState({billing_valid : isValid})

  on_cancel_billing = () => this.setState({ billing_modal_visible: false }, this.state.on_close)

  on_save_billing = () => {
    let $this  = this
    $this.form.validateFields((err, values) => {
      if (err) {
        return message.error('Please fill required fields')
      }

      $this.setState({billing_loading:true})

      const { name, number, expiry, cvc } = values
      let {email, first_name, last_name} = this.props.user

      let subscription = {
        customer_subscription: {
          subscription: {
            product_handle : 'CloudFlyer-free',
            coupon_code    : '',

            customer_attributes: {
              first_name : first_name,
              last_name  : last_name,
              email      : email
            },

            credit_card_attributes: {
              full_number      : number,
              expiration_month : expiry.split('/')[0],
              expiration_year  : expiry.split('/')[1],
              billing_address  : '',
              billing_city     : '',
              billing_state    : '',
              billing_country  : 'USA',
              billing_zip      : ''
            }
          }
        }
      }

      CloudFlyerAPI
          .billing
          .subscriptions(subscription)
        .then(()=> {
          $this.setState({billing_loading: false, billing_modal_visible:false}, ()=>{
            $this.props.refresh()
            if($this.state.on_close){
              $this.state.on_close(subscription)
            }
          })
        })
        .catch(err=> {
          $this.setState({billing_loading: false}, $this.props.refresh)

          if(((err.response||{}).data||{})){
            if(((err.response||{}).data||{}).chargify_errors){
              return message.error(((err.response||{}).data||{}).chargify_errors[0])
            }
            message.error(((err.response||{}).data||{}).message)
          } else {
            message.error(err.message)
          }
        })
    })
  }

  render() {
    const {billing_modal_visible, focused, billing_loading, billing:{name, number, expiry, cvc}} = this.state
    const {title} = this.props

    return (
      <div className='billing-form'>
        <PaymentForm title   = {title}
                     ref     = {form => this.form = form}
                     visible = {billing_modal_visible}
                     loading = {billing_loading}

                     name    = {name}
                     number  = {number}
                     expiry  = {expiry||'##/##'}
                     cvc     = {cvc}
                     focused = {focused}

                     on_cancel = {this.on_cancel_billing}
                     on_save   = {this.on_save_billing}
                     on_focus  = {this.on_focus}
                     on_change = {this.on_billing_change}
                     callback  = {this.billing_callback}
        />
      </div>
    )
  }
}
